export const RECEIPT_PROMO_IMAGE_SIZE_HINT =
  "Recommended image size: 800 × 450 px (16:9 landscape). JPG or PNG under 500 KB.";

export const RECEIPT_PROMO_IMAGE_ASPECT = "16 / 9";
